var Storeclicked = ( state = false, action ) => {
    if ( action.type === 'storedirected' ) {
        return action.payload;
    } else {
        return false;
    }
}
export default Storeclicked;